import type { UseQueryOptions } from '@/shared/lib/query-client'
import type { QueryClient } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { useQuery, useQueryClient } from '@tanstack/react-query'

import {
	buildPickerForest,
	optimizationGroupQueries,
} from '@/entities/optimization-group'

import { getProductGroupsMapByOgId } from '../lib/getProductGroupsMapByOgId'

export const optimizationGroupsQueries = {
	productGroupsMap: (queryClient: QueryClient) => ({
		queryKey: ['product-groups-map'],
		queryFn: async () => {
			const groups = await queryClient.ensureQueryData(
				optimizationGroupQueries.list()
			)
			const productGroups = await queryClient.ensureQueryData(
				optimizationGroupQueries.productGroups({
					include_full_categories: true,
				})
			)
			const categories = await queryClient.ensureQueryData(
				optimizationGroupQueries.dryCategories()
			)

			const { pickerForest } = buildPickerForest(categories, productGroups)

			return getProductGroupsMapByOgId(groups ?? [], pickerForest)
		},
	}),
}
type ProductGroupsMapModel = Record<string, string[]>
export const useProductGroupsMapQuery = <T = ProductGroupsMapModel>(
	options?: UseQueryOptions<ProductGroupsMapModel, AxiosError, T>
) => {
	const queryClient = useQueryClient()

	return useQuery({
		...optimizationGroupsQueries.productGroupsMap(queryClient),
		...(options || {}),
	})
}
